import { z } from 'zod';
export const DbHealthSchema = z.object({
    configured: z.boolean(),
    reachable: z.boolean(),
    error: z.string().nullable(),
});
export const HealthSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    commit: z.string(),
    uptimeSeconds: z.number(),
    db: DbHealthSchema,
});
/** Denni kurzy CNB. null = kurz se zatim nepodarilo stahnout. */
export const FxResponseSchema = z.object({
    eurCzk: z.number().positive().nullable(),
    plnCzk: z.number().positive().nullable(),
    /** Den, ke kteremu CNB kurz vyhlasila (YYYY-MM-DD). */
    date: z.iso.date().nullable(),
});
export const OkResponseSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=api.js.map